import Vue from "vue";
import Router from "vue-router";
import "vuetify/dist/vuetify.min.css";
import Login from "@/components/Login";
import Dashboard from "@/views/Dashboard";
import Lesson from "@/views/Lesson";
import Practice from "@/views/Practice";
import PracticeQuiz from "@/components/PracticeQuiz";
import Quiz from "@/views/Quiz";
import About from "@/views/About";
import Logout from "@/components/Logout";
import Settings from "@/views/Settings";
import Grammar from "@/views/Grammar";
import Vocabulary from "@/views/Vocabulary";
import Profile from "@/views/Profile";
import Conjugate from "@/views/Conjugate";
import Error from "@/components/Error";
import Progress from "@/components/Progress";
import Account from "@/components/Account";
import Lessons from "@/views/Lessons";
import VocabItem from "@/views/VocabItem";
import PracticeConfig from "@/views/PracticeConfig";
import PaleographyQuestion from "@/components/QuizTypes/PaleographyQuestion";
import Paleography from "@/views/Paleography";
import PaleoPrimer from "@/views/PaleoPrimer";
import VueRouter from 'vue-router'
Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/Login",
    name: "Login",
    component: Login
  },
  {
    path: "/About",
    name: "About",
    component: About
  },
  {
    path: "/Lesson",
    name: "Lesson",
    component: Lesson
  },
  {
    path: "/Lessons",
    name: "Lessons",
    component: Lessons
  },
  {
    path: "/Practice",
    name: "Practice",
    component: Practice
  },
  {
    path: "/PracticeQuiz/:type",
    name: "PracticeQuiz",
    component: PracticeQuiz
  },
  {
    path: "/Quiz",
    name: "Quiz",
    component: Quiz
  },
  {
    path: "/Logout",
    name: "Logout",
    component: Logout
  },
  {
    path: "/Grammar",
    name: "Grammar",
    component: Grammar
  },
  {
    path: "/Vocabulary",
    name: "Vocabulary",
    component: Vocabulary
  },
  {
    path: "/Settings",
    name: "Settings",
    component: Settings
  },
  {
    path: "/Profile",
    name: "Profile",
    component: Profile
  },
  {
    path: "/Error",
    name: "Error",
    component: Error
  },
  {
    path: "/Progress",
    name: "Progress",
    component: Progress
  },
  {
    path: "/Account",
    name: "Account",
    component: Account
  },
  {
    path: "/Conjugate",
    name: "Conjugate",
    component: Conjugate
  },
  {
    path: "/PaleographyQuestion/:level",
    name: "PaleographyQuestion",
    component: PaleographyQuestion
  },
  {
    path: "/PaleoPrimer/:part",
    name: "PaleoPrimer",
    component: PaleoPrimer
  },
  {
    path: "/Public/PracticeQuiz/Paleography",
    name: "PublicPracticeQuiz",
    component: PracticeQuiz,
    meta: { public: true }
  },
  {
    path: "/Public/PaleoPrimer/:part",
    name: "PublicPaleoPrimer",
    component: PaleoPrimer,
    meta: { public: true }
  },
  {
    path: "/Public/Paleography",
    name: "PublicPaleography",
    component: Paleography,
    meta: { public: true }
  },
  {
    path: "/Public/Practice",
    name: "PublicPractice",
    component: Practice,
    meta: {public: true}
  },
  {
    path: "/Public/PracticeQuiz/:type",
    name: "PublicPractice",
    component: PracticeQuiz,
    meta: {public: true}
  },
  {
    path: "/Public/PracticeQuiz",
    name: "PublicPractice",
    component: PracticeQuiz,
    meta: {public: true}
  },
  {
    path: "/Paleography",
    name: "Paleography",
    component: Paleography
  },
  {
    path: "/practiceconfig",
    name: "PracticeConfig",
    component: PracticeConfig
  },
  {
    path: "/Vocab/:id",
    name: "VocabItem",
    component: VocabItem
  }
];

const router = new VueRouter({
  routes, // short for `routes: routes`
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
